// TEAMS study-question groups in display order (truth → supplication).
export const TEAMS_STUDY_QUESTION_KEYS = [
  'truthStudyQuestions',
  'equipStudyQuestions',
  'accountStudyQuestions',
  'missionStudyQuestions',
  'supplicationStudyQuestions',
]

/**
 * Assigns sequential runtime questionNumber values across the five TEAMS
 * question groups for one unit. Numbering starts at 1 and resets per unit.
 * Does not mutate the input unit; returns a shallow copy with mapped arrays.
 */
export function assignUnitStudyQuestionNumbers(unit) {
  if (!unit || typeof unit !== 'object') {
    return unit
  }

  let counter = 1
  const numberedUnit = { ...unit }

  for (const key of TEAMS_STUDY_QUESTION_KEYS) {
    const questions = unit[key]
    if (!Array.isArray(questions) || questions.length === 0) {
      continue
    }

    numberedUnit[key] = questions.map((question) => {
      if (question == null || typeof question !== 'object') {
        return question
      }
      return { ...question, questionNumber: counter++ }
    })
  }

  return numberedUnit
}
